import { useState } from "react";
import { Radio } from "lucide-react";

export const StationLogo = ({ src, className = "h-12 w-12", iconSize = 18 }) => {
  const [failed, setFailed] = useState(false);
  if (!src || failed) {
    return (
      <div className={`flex shrink-0 items-center justify-center rounded-md bg-gradient-to-br from-amber-100 to-orange-50 text-amber-700 ${className}`}>
        <Radio size={iconSize} strokeWidth={1.5} />
      </div>
    );
  }
  return <img src={src.replace(/^http:\/\//i, "https://")} alt="" loading="lazy" onError={() => setFailed(true)} className={`shrink-0 rounded-md border border-zinc-100 bg-white object-contain p-1 ${className}`} />;
};

export const LiveDot = ({ className = "" }) => (
  <span className={`relative flex h-2 w-2 ${className}`}>
    <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-red-500 opacity-60" />
    <span className="relative inline-flex h-2 w-2 rounded-full bg-red-500" />
  </span>
);

export const Equalizer = () => (
  <span className="flex h-3 items-end gap-[2px]" data-testid="station-playing-indicator">
    {[0, 150, 300].map((d) => (
      <span key={d} className="w-[3px] animate-[eq_0.9s_ease-in-out_infinite] rounded-sm bg-amber-600" style={{ animationDelay: `${d}ms`, height: "100%" }} />
    ))}
  </span>
);
